import { node, arrayOf, string, oneOfType } from 'prop-types'

const Form = ({ children, cssClass = '', name = '', autoComplete = 'off' }) => {
  return (
    <form className={cssClass} name={name} autoComplete={autoComplete}>
      {children}
    </form>
  )
}

Form.propTypes = {
  autoComplete: string,
  children: oneOfType([arrayOf(node), node]),
  cssClass: string,
  id: string,
  name: string
}

export default Form
